import { mapCollection } from '../../utils/collection.utils';
import { Level } from '../level';

export class LevelBuilder {
  static fromJson(json) {
    return (json)
      ? new Level(
        json.hash,
        json.level,
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(LevelBuilder.fromJson, list) : [];
  }
}
